var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.615,
    y: 0.5,
    width: 32.115,
    height: 19,
    rx: 1.5,
    fill: "#fff",
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.854 13.182l1.018-6.358H16.5l-1.018 6.358h-1.628zM21.385 6.98a4 4 0 00-1.458-.266c-1.61 0-2.742.862-2.751 2.098-.01.914.808 1.424 1.425 1.727.634.312.847.51.845.79-.005.425-.506.62-.974.62-.652 0-.998-.096-1.533-.333l-.21-.101-.227 1.423c.38.177 1.083.33 1.813.339 1.71 0 2.821-.853 2.834-2.172.006-.725-.428-1.274-1.367-1.728-.569-.294-.918-.49-.914-.788 0-.264.295-.547.933-.547.532-.009.917.115 1.218.244l.146.073.22-1.379zM23.552 10.928c.135-.365.649-1.777.649-1.777-.01.017.134-.368.216-.607l.11.549.377 1.835h-1.352zm2.008-4.097h-1.257c-.39 0-.683.112-.854.527l-2.417 5.827h1.71s.279-.784.342-.956l2.085.003c.049.222.198.953.198.953h1.51L25.56 6.83zM12.489 6.83l-1.593 4.334-.171-.88c-.297-1.016-1.22-2.116-2.255-2.668l1.458 5.56h1.722l2.563-6.346H12.49z",
    fill: "#26337A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.417 6.825H6.792l-.021.132c2.042.527 3.393 1.798 3.954 3.326l-.57-2.921c-.099-.403-.385-.523-.738-.537z",
    fill: "#EC982D"
  })));
};

export default SvgVisa;